module.exports = __webpack_public_path__ + "img/3gtgs.ff384fec.png";